<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <el-col :span="4" :xs="24">
          <el-form-item prop="thirdPartyOrderId">
            <el-input
              v-model="params.weChatOrderSn"
              maxlength="32"
              placeholder="订单单号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="24">
          <el-form-item prop="state">
            <el-select v-model="params.state" placeholder="请选择提现状态">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7" :xs="24">
          <el-form-item>
            <!-- <el-date-picker
                v-model="time"
                :clearable="false"
                :picker-options="pickerOptions"
                end-placeholder="结束日期"
                range-separator="至"
                start-placeholder="开始日期"
                type="daterange"/> -->
            <lp-date-picker
              ref="lpDatePicker"
              @finish="handleLpDatePickerChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
        <el-col :span="2" :xs="12" class="xs-mp-10">
          <el-button type="primary" @click="open">提现</el-button>
        </el-col>
        <el-col :span="2" :xs="12" class="xs-mp-10">
          <el-button
            type="primary"
            @click="withdrawSetDialog = withdrawSetDialogOld = true"
            >提现设置</el-button
          >
        </el-col>
      </el-form>
    </el-row>
    <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
      :default-sort="{ prop: 'id', order: 'descending' }"
    >
      <el-table-column fixed label="流水号" prop="id" sortable="custom" />
      <el-table-column label="订单单号" prop="weChatOrderSn" />
      <el-table-column label="提现类型" prop="withdraw_type">
        <template #default="scope">
          {{ scope.row.withdraw_type === "1" ? "微信提现" : "银行卡提现" }}
        </template>
      </el-table-column>
      <el-table-column label="姓名/昵称">
        <template #default="scope">
          {{
            scope.row.weChatUserInfo
              ? scope.row.weChatUserInfo.nickName
              : scope.row.card_name
          }}
        </template>
      </el-table-column>
      <el-table-column label="卡号/openid">
        <template #default="scope">
          {{
            scope.row.weChatUserInfo
              ? scope.row.weChatUserInfo.openid
              : scope.row.card_num
          }}
        </template>
      </el-table-column>
      <el-table-column label="金额" prop="money" />
      <el-table-column label="状态">
        <template slot-scope="scope">
          <template v-if="scope.row.state === '-1'"> 拒绝提现 </template>
          <template v-if="scope.row.state === '0'"> 待处理 </template>
          <template v-if="scope.row.state === '2' || scope.row.state === '3'">
            处理中
          </template>
          <template v-if="scope.row.state === '1' || scope.row.state === '5'">
            提现成功
          </template>
          <template v-if="scope.row.state === '4'"> 提现失败 </template>
          <template v-if="scope.row.state === '6'"> 已回退余额 </template>
        </template>
      </el-table-column>
      <el-table-column label="提现时间" prop="creatTime">
        <template #default="scope">
          {{ timeFormat(scope.row.creatTime) }}
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark" />
    </el-table>
    <page :current="current" :size="size" :total="total" />
    <div>提示:净收入=全部收入-全部指出+余额提现</div>
    <withdraw-dialog
      :dialog="withdrawDialog"
      :mode="mode"
      :money="info.money"
      :info="info"
    />

    <withdraw-set-dialog-old
      v-if="info.id == 68"
      :auto-withdraw="autoWithdraw"
      :bank-num="bankNum"
      :dialog="withdrawSetDialogOld"
      :mode="mode"
    />
    <withdraw-set-dialog
      v-else
      :auto-withdraw="autoWithdraw"
      :info="info"
      :bank-num="bankNum"
      :dialog="withdrawSetDialog"
      :mode="mode"
    />
  </div>
</template>

<script>
import agentGetWithdrawLogPage from "@/api/fund/withdraw-log-manage/agentGetWithdrawLogPage";
import agentGetOwnDetails from "@/api/user/agent-manage/agentGetOwnDetails";
import Page from "@/components/Page";
import WithdrawDialog from "@/components/StatisticsCentre/RecordDetail/withdrawDialog";
import WithdrawSetDialog from "@/components/StatisticsCentre/RecordDetail/withdrawSetDialog";
import withdrawSetDialogOld from "@/components/StatisticsCentre/RecordDetail/withdrawSetDialogOld";
import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import pageMixin from "@/mixin/pageMixin";
import resDispose from "@/mixin/resDisposeMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";

export default {
  name: "RecordDetail",
  components: { WithdrawDialog, WithdrawSetDialog, withdrawSetDialogOld, Page },
  mixins: [
    pageMixin,
    createdMixin,
    timeMixin,
    searchMixin,
    resDispose,
    dialogMixin,
  ],
  data() {
    return {
      bankNum: "",
      mode: "no",
      bindWithdrawDialog: false,
      withdrawDialog: false,
      withdrawSetDialog: false,
      withdrawSetDialogOld: false,
      time: [],
      autoWithdraw: undefined,
      options: [
        { value: -1, label: "失败" },
        { value: 0, label: "待处理" },
        { value: 1, label: "成功" },
      ],
      params: {
        weChatOrderSn: undefined,
        startTime: undefined,
        endTime: undefined,
        memberId: undefined,
        memberType: undefined,
        state: undefined,
        sortName: "id",
        sortType: "DESC",
      },
      records: [],
      info: {},
    };
  },
  methods: {
    resetFields() {
      this.params.weChatOrderSn = undefined;
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }
      console.log(this.params.sortName);
      // console.log(this.params.sortType)
      this.fetchData();
    },
    open() {
      // this.info.bankNum === "" && this.info.weChatUser === undefined

      if (
        this.info.id == 68
          ? this.info.bankNum === "" && this.info.weChatUser === undefined
          : !this.info.douGongInfo
      ) {
        this.withdrawSetDialog = this.withdrawSetDialogOld = true;
      } else {
        this.withdrawDialog = true;
      }
    },
    fetchData() {
      this.loadTable = true;
      agentGetWithdrawLogPage(this.params, this.current)
        .then((res) => {
          this.records = res.data.records;
          this.total = res.data.total;
        })
        .finally(() => {
          this.loadTable = false;
        });
      agentGetOwnDetails().then((res) => {
        this.info = res.data;
        if (this.info.bankNum !== "") {
          this.mode = "card";
          this.bankNum = this.info.bankNum;
        } else if (this.info.weChatUser !== undefined) {
          this.mode = "weChat";
        }
        this.autoWithdraw = res.data.autoWithdraw;
      });
    },
  },
};
</script>
